import { exportXlsxWithFontSize } from '../../../../shared/xlsx-export';
import { csvExporter } from '../../../../shared/csv';
import { exportPDF } from '../../../../shared/helpers';
import { IServiceGroups } from './utils';
import { UserOptions } from 'jspdf-autotable';

type ExportRow = {
    'Vehicle Name': string;
    'Service Type': string;
    'Last Service': string;
    'Due Date': string;
    'Days Left': string | number;
};

const formatDaysLeft = (daysLeft: number): string | number => {
    if (daysLeft < 0) return 'Past Due';
    return daysLeft;
};

const toRows = (data: IServiceGroups): ExportRow[] => {
    const rows: ExportRow[] = [];

    const addItems = (items: IServiceGroups[keyof IServiceGroups]) => {
        items.forEach((item) => {
            rows.push({
                'Vehicle Name': item.vehicleName,
                'Service Type': item.itemName,
                'Last Service': item.lastServiceDate,
                'Due Date': item.dueDate,
                'Days Left': formatDaysLeft(item.daysLeft),
            });
        });
    };

    addItems(data.expired);
    addItems(data.days30);

    return rows;
};

export const exportServiceReportCsv = (data: IServiceGroups) => {
    const rows = toRows(data);
    const header = ['Vehicle Name', 'Service Type', 'Last Service', 'Due Date', 'Days Left'];
    const body = rows.map((row) => [
        row['Vehicle Name'],
        row['Service Type'],
        row['Last Service'],
        row['Due Date'],
        String(row['Days Left']),
    ]);

    csvExporter('ServiceNeededReport.csv')([header, ...body]);
};

export const exportServiceReportXlsx = (data: IServiceGroups) => {
    const rows = toRows(data);
    exportXlsxWithFontSize({
        sheetName: 'Service Needed',
        fileName: 'ServiceNeededReport.xlsx',
        columns: [
            { header: 'Vehicle Name', key: 'Vehicle Name', width: 25 },
            { header: 'Service Type', key: 'Service Type', width: 20 },
            { header: 'Last Service', key: 'Last Service', width: 18 },
            { header: 'Due Date', key: 'Due Date', width: 18 },
            { header: 'Days Left', key: 'Days Left', width: 15 },
        ],
        rows,
    });
};

export const exportServiceReportPdf = (data: IServiceGroups) => {
    const rows = toRows(data).map((row) => [
        row['Vehicle Name'],
        row['Service Type'],
        row['Last Service'],
        row['Due Date'],
        String(row['Days Left']),
    ]);

    const table: UserOptions = {
        head: [['Vehicle Name', 'Service Type', 'Last Service', 'Due Date', 'Days Left']],
        body: rows,
        styles: { fontSize: 9 },
    };

    exportPDF({ fileName: 'ServiceNeededReport.pdf', data: [table] });
};